import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
    Settings as SettingsIcon,
    User,
    Key,
    Database,
    Bell,
    Shield,
    Download,
    Upload,
    Trash2,
    Save
} from 'lucide-react';

const Settings = () => {
    const { user } = useAuth();
    const [activeTab, setActiveTab] = useState('profile');
    const [settings, setSettings] = useState({
        notifications: {
            email: true,
            browser: true,
            newContract: true,
            documentReminder: true,
            paymentAlert: false
        },
        display: {
            itemsPerPage: 10,
            dateFormat: 'YYYY-MM-DD',
            currency: 'KRW',
            theme: 'light'
        },
        security: {
            twoFactor: false,
            sessionTimeout: 30,
            autoLogout: true
        }
    });

    const handleSettingChange = (category, key, value) => {
        setSettings(prev => ({
            ...prev,
            [category]: {
                ...prev[category],
                [key]: value
            }
        }));
    };

    const tabs = [
        { id: 'profile', label: '프로필', icon: User },
        { id: 'security', label: '보안', icon: Shield },
        { id: 'notifications', label: '알림', icon: Bell },
        { id: 'display', label: '화면 설정', icon: SettingsIcon },
        { id: 'data', label: '데이터 관리', icon: Database }
    ];

    const renderTabContent = () => {
        switch (activeTab) {
            case 'profile':
                return (
                    <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">프로필 정보</h3>
                        <div className="grid grid-2" style={{ gap: '20px' }}>
                            <div>
                                <label className="text-sm font-medium text-gray-700" style={{ display: 'block', marginBottom: '8px' }}>
                                    사용자 ID
                                </label>
                                <input
                                    type="text"
                                    value={user?.idString || ''}
                                    disabled
                                    className="input"
                                    style={{ backgroundColor: '#f9fafb' }}
                                />
                            </div>
                            <div>
                                <label className="text-sm font-medium text-gray-700" style={{ display: 'block', marginBottom: '8px' }}>
                                    이름
                                </label>
                                <input
                                    type="text"
                                    value={user?.name || ''}
                                    className="input"
                                />
                            </div>
                            <div>
                                <label className="text-sm font-medium text-gray-700" style={{ display: 'block', marginBottom: '8px' }}>
                                    역할
                                </label>
                                <input
                                    type="text"
                                    value={user?.role || ''}
                                    disabled
                                    className="input"
                                    style={{ backgroundColor: '#f9fafb' }}
                                />
                            </div>
                            <div>
                                <label className="text-sm font-medium text-gray-700" style={{ display: 'block', marginBottom: '8px' }}>
                                    이메일
                                </label>
                                <input
                                    type="email"
                                    placeholder="이메일을 입력하세요"
                                    className="input"
                                />
                            </div>
                        </div>
                        <div className="mt-6">
                            <button className="btn btn-primary">
                                <Save size={16} />
                                프로필 저장
                            </button>
                        </div>
                    </div>
                );

            case 'security':
                return (
                    <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">보안 설정</h3>
                        <div style={{ marginBottom: '24px' }}>
                            <h4 className="font-medium text-gray-700 mb-3">비밀번호 변경</h4>
                            <div className="grid grid-1" style={{ gap: '16px', maxWidth: '400px' }}>
                                <div>
                                    <label className="text-sm font-medium text-gray-700" style={{ display: 'block', marginBottom: '8px' }}>
                                        현재 비밀번호
                                    </label>
                                    <input type="password" className="input" />
                                </div>
                                <div>
                                    <label className="text-sm font-medium text-gray-700" style={{ display: 'block', marginBottom: '8px' }}>
                                        새 비밀번호
                                    </label>
                                    <input type="password" className="input" />
                                </div>
                                <div>
                                    <label className="text-sm font-medium text-gray-700" style={{ display: 'block', marginBottom: '8px' }}>
                                        새 비밀번호 확인
                                    </label>
                                    <input type="password" className="input" />
                                </div>
                                <button className="btn btn-primary" style={{ width: 'fit-content' }}>
                                    <Key size={16} />
                                    비밀번호 변경
                                </button>
                            </div>
                        </div>

                        <div style={{ marginBottom: '24px', paddingTop: '24px', borderTop: '1px solid #e5e7eb' }}>
                            <h4 className="font-medium text-gray-700 mb-3">보안 옵션</h4>
                            <div style={{ gap: '16px' }}>
                                <div className="flex-between" style={{ padding: '12px 0' }}>
                                    <div>
                                        <p className="font-medium text-gray-900">2단계 인증</p>
                                        <p className="text-sm text-gray-600">로그인 시 추가 보안 단계를 거칩니다</p>
                                    </div>
                                    <label style={{ position: 'relative', display: 'inline-block', width: '44px', height: '24px' }}>
                                        <input
                                            type="checkbox"
                                            checked={settings.security.twoFactor}
                                            onChange={(e) => handleSettingChange('security', 'twoFactor', e.target.checked)}
                                            style={{ opacity: 0, width: 0, height: 0 }}
                                        />
                                        <span style={{
                                            position: 'absolute',
                                            cursor: 'pointer',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: settings.security.twoFactor ? '#3b82f6' : '#cbd5e1',
                                            borderRadius: '24px',
                                            transition: '0.4s'
                                        }}>
                                            <span style={{
                                                position: 'absolute',
                                                content: '',
                                                height: '18px',
                                                width: '18px',
                                                left: settings.security.twoFactor ? '23px' : '3px',
                                                bottom: '3px',
                                                backgroundColor: 'white',
                                                borderRadius: '50%',
                                                transition: '0.4s'
                                            }} />
                                        </span>
                                    </label>
                                </div>

                                <div className="flex-between" style={{ padding: '12px 0' }}>
                                    <div>
                                        <p className="font-medium text-gray-900">자동 로그아웃</p>
                                        <p className="text-sm text-gray-600">일정 시간 후 자동으로 로그아웃됩니다</p>
                                    </div>
                                    <label style={{ position: 'relative', display: 'inline-block', width: '44px', height: '24px' }}>
                                        <input
                                            type="checkbox"
                                            checked={settings.security.autoLogout}
                                            onChange={(e) => handleSettingChange('security', 'autoLogout', e.target.checked)}
                                            style={{ opacity: 0, width: 0, height: 0 }}
                                        />
                                        <span style={{
                                            position: 'absolute',
                                            cursor: 'pointer',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: settings.security.autoLogout ? '#3b82f6' : '#cbd5e1',
                                            borderRadius: '24px',
                                            transition: '0.4s'
                                        }}>
                                            <span style={{
                                                position: 'absolute',
                                                content: '',
                                                height: '18px',
                                                width: '18px',
                                                left: settings.security.autoLogout ? '23px' : '3px',
                                                bottom: '3px',
                                                backgroundColor: 'white',
                                                borderRadius: '50%',
                                                transition: '0.4s'
                                            }} />
                                        </span>
                                    </label>
                                </div>

                                <div style={{ padding: '12px 0' }}>
                                    <label className="font-medium text-gray-900" style={{ display: 'block', marginBottom: '8px' }}>
                                        세션 타임아웃 (분)
                                    </label>
                                    <select
                                        value={settings.security.sessionTimeout}
                                        onChange={(e) => handleSettingChange('security', 'sessionTimeout', parseInt(e.target.value))}
                                        className="select"
                                        style={{ width: '200px' }}
                                    >
                                        <option value={15}>15분</option>
                                        <option value={30}>30분</option>
                                        <option value={60}>1시간</option>
                                        <option value={120}>2시간</option>
                                        <option value={240}>4시간</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                );

            case 'notifications':
                return (
                    <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">알림 설정</h3>
                        <div style={{ gap: '16px' }}>
                            <div className="flex-between" style={{ padding: '12px 0', borderBottom: '1px solid #f3f4f6' }}>
                                <div>
                                    <p className="font-medium text-gray-900">이메일 알림</p>
                                    <p className="text-sm text-gray-600">중요한 업데이트를 이메일로 받습니다</p>
                                </div>
                                <label style={{ position: 'relative', display: 'inline-block', width: '44px', height: '24px' }}>
                                    <input
                                        type="checkbox"
                                        checked={settings.notifications.email}
                                        onChange={(e) => handleSettingChange('notifications', 'email', e.target.checked)}
                                        style={{ opacity: 0, width: 0, height: 0 }}
                                    />
                                    <span style={{
                                        position: 'absolute',
                                        cursor: 'pointer',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: settings.notifications.email ? '#3b82f6' : '#cbd5e1',
                                        borderRadius: '24px',
                                        transition: '0.4s'
                                    }}>
                                        <span style={{
                                            position: 'absolute',
                                            content: '',
                                            height: '18px',
                                            width: '18px',
                                            left: settings.notifications.email ? '23px' : '3px',
                                            bottom: '3px',
                                            backgroundColor: 'white',
                                            borderRadius: '50%',
                                            transition: '0.4s'
                                        }} />
                                    </span>
                                </label>
                            </div>

                            <div className="flex-between" style={{ padding: '12px 0', borderBottom: '1px solid #f3f4f6' }}>
                                <div>
                                    <p className="font-medium text-gray-900">브라우저 알림</p>
                                    <p className="text-sm text-gray-600">브라우저 푸시 알림을 받습니다</p>
                                </div>
                                <label style={{ position: 'relative', display: 'inline-block', width: '44px', height: '24px' }}>
                                    <input
                                        type="checkbox"
                                        checked={settings.notifications.browser}
                                        onChange={(e) => handleSettingChange('notifications', 'browser', e.target.checked)}
                                        style={{ opacity: 0, width: 0, height: 0 }}
                                    />
                                    <span style={{
                                        position: 'absolute',
                                        cursor: 'pointer',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: settings.notifications.browser ? '#3b82f6' : '#cbd5e1',
                                        borderRadius: '24px',
                                        transition: '0.4s'
                                    }}>
                                        <span style={{
                                            position: 'absolute',
                                            content: '',
                                            height: '18px',
                                            width: '18px',
                                            left: settings.notifications.browser ? '23px' : '3px',
                                            bottom: '3px',
                                            backgroundColor: 'white',
                                            borderRadius: '50%',
                                            transition: '0.4s'
                                        }} />
                                    </span>
                                </label>
                            </div>

                            <div className="flex-between" style={{ padding: '12px 0', borderBottom: '1px solid #f3f4f6' }}>
                                <div>
                                    <p className="font-medium text-gray-900">신규 계약 알림</p>
                                    <p className="text-sm text-gray-600">새로운 계약이 등록될 때 알림을 받습니다</p>
                                </div>
                                <label style={{ position: 'relative', display: 'inline-block', width: '44px', height: '24px' }}>
                                    <input
                                        type="checkbox"
                                        checked={settings.notifications.newContract}
                                        onChange={(e) => handleSettingChange('notifications', 'newContract', e.target.checked)}
                                        style={{ opacity: 0, width: 0, height: 0 }}
                                    />
                                    <span style={{
                                        position: 'absolute',
                                        cursor: 'pointer',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: settings.notifications.newContract ? '#3b82f6' : '#cbd5e1',
                                        borderRadius: '24px',
                                        transition: '0.4s'
                                    }}>
                                        <span style={{
                                            position: 'absolute',
                                            content: '',
                                            height: '18px',
                                            width: '18px',
                                            left: settings.notifications.newContract ? '23px' : '3px',
                                            bottom: '3px',
                                            backgroundColor: 'white',
                                            borderRadius: '50%',
                                            transition: '0.4s'
                                        }} />
                                    </span>
                                </label>
                            </div>

                            <div className="flex-between" style={{ padding: '12px 0', borderBottom: '1px solid #f3f4f6' }}>
                                <div>
                                    <p className="font-medium text-gray-900">서류 알림</p>
                                    <p className="text-sm text-gray-600">미제출 서류가 있을 때 알림을 받습니다</p>
                                </div>
                                <label style={{ position: 'relative', display: 'inline-block', width: '44px', height: '24px' }}>
                                    <input
                                        type="checkbox"
                                        checked={settings.notifications.documentReminder}
                                        onChange={(e) => handleSettingChange('notifications', 'documentReminder', e.target.checked)}
                                        style={{ opacity: 0, width: 0, height: 0 }}
                                    />
                                    <span style={{
                                        position: 'absolute',
                                        cursor: 'pointer',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: settings.notifications.documentReminder ? '#3b82f6' : '#cbd5e1',
                                        borderRadius: '24px',
                                        transition: '0.4s'
                                    }}>
                                        <span style={{
                                            position: 'absolute',
                                            content: '',
                                            height: '18px',
                                            width: '18px',
                                            left: settings.notifications.documentReminder ? '23px' : '3px',
                                            bottom: '3px',
                                            backgroundColor: 'white',
                                            borderRadius: '50%',
                                            transition: '0.4s'
                                        }} />
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                );

            case 'display':
                return (
                    <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">화면 설정</h3>
                        <div className="grid grid-2" style={{ gap: '20px' }}>
                            <div>
                                <label className="text-sm font-medium text-gray-700" style={{ display: 'block', marginBottom: '8px' }}>
                                    페이지당 항목 수
                                </label>
                                <select
                                    value={settings.display.itemsPerPage}
                                    onChange={(e) => handleSettingChange('display', 'itemsPerPage', parseInt(e.target.value))}
                                    className="select"
                                >
                                    <option value={10}>10개</option>
                                    <option value={20}>20개</option>
                                    <option value={50}>50개</option>
                                    <option value={100}>100개</option>
                                </select>
                            </div>

                            <div>
                                <label className="text-sm font-medium text-gray-700" style={{ display: 'block', marginBottom: '8px' }}>
                                    날짜 형식
                                </label>
                                <select
                                    value={settings.display.dateFormat}
                                    onChange={(e) => handleSettingChange('display', 'dateFormat', e.target.value)}
                                    className="select"
                                >
                                    <option value="YYYY-MM-DD">2025-05-25</option>
                                    <option value="MM/DD/YYYY">05/25/2025</option>
                                    <option value="DD/MM/YYYY">25/05/2025</option>
                                    <option value="YYYY년 MM월 DD일">2025년 05월 25일</option>
                                </select>
                            </div>

                            <div>
                                <label className="text-sm font-medium text-gray-700" style={{ display: 'block', marginBottom: '8px' }}>
                                    통화 단위
                                </label>
                                <select
                                    value={settings.display.currency}
                                    onChange={(e) => handleSettingChange('display', 'currency', e.target.value)}
                                    className="select"
                                >
                                    <option value="KRW">원 (₩)</option>
                                    <option value="USD">달러 ($)</option>
                                    <option value="EUR">유로 (€)</option>
                                </select>
                            </div>

                            <div>
                                <label className="text-sm font-medium text-gray-700" style={{ display: 'block', marginBottom: '8px' }}>
                                    테마
                                </label>
                                <select
                                    value={settings.display.theme}
                                    onChange={(e) => handleSettingChange('display', 'theme', e.target.value)}
                                    className="select"
                                >
                                    <option value="light">라이트</option>
                                    <option value="dark">다크</option>
                                    <option value="auto">시스템 설정</option>
                                </select>
                            </div>
                        </div>
                    </div>
                );

            case 'data':
                return (
                    <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">데이터 관리</h3>

                        <div style={{ marginBottom: '24px' }}>
                            <h4 className="font-medium text-gray-700 mb-3">백업 및 복원</h4>
                            <div className="flex" style={{ gap: '12px', marginBottom: '16px' }}>
                                <button className="btn btn-primary">
                                    <Download size={16} />
                                    데이터 백업
                                </button>
                                <button className="btn btn-secondary">
                                    <Upload size={16} />
                                    데이터 복원
                                </button>
                            </div>
                            <p className="text-sm text-gray-600">
                                모든 계약, 사망자, 묘소 정보를 안전하게 백업하고 복원할 수 있습니다.
                            </p>
                        </div>

                        <div style={{ marginBottom: '24px', paddingTop: '24px', borderTop: '1px solid #e5e7eb' }}>
                            <h4 className="font-medium text-gray-700 mb-3">데이터 내보내기</h4>
                            <div className="grid grid-2" style={{ gap: '12px', marginBottom: '16px' }}>
                                <button className="btn btn-secondary">
                                    <Download size={16} />
                                    계약 데이터 (Excel)
                                </button>
                                <button className="btn btn-secondary">
                                    <Download size={16} />
                                    사망자 데이터 (CSV)
                                </button>
                                <button className="btn btn-secondary">
                                    <Download size={16} />
                                    묘소 현황 (PDF)
                                </button>
                                <button className="btn btn-secondary">
                                    <Download size={16} />
                                    통계 보고서 (PDF)
                                </button>
                            </div>
                            <p className="text-sm text-gray-600">
                                각종 데이터를 다양한 형식으로 내보내기할 수 있습니다.
                            </p>
                        </div>

                        <div style={{ paddingTop: '24px', borderTop: '1px solid #e5e7eb' }}>
                            <h4 className="font-medium text-gray-700 mb-3 text-red-600">위험 구역</h4>
                            <div style={{ padding: '16px', backgroundColor: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px' }}>
                                <p className="text-sm text-red-600 mb-3">
                                    <strong>주의:</strong> 아래 작업은 되돌릴 수 없습니다. 신중하게 진행하세요.
                                </p>
                                <button className="btn btn-danger">
                                    <Trash2 size={16} />
                                    모든 데이터 삭제
                                </button>
                            </div>
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div>
            <div className="flex-between mb-6">
                <h1 className="text-2xl font-bold text-gray-900">설정</h1>
                <button className="btn btn-primary">
                    <Save size={20} />
                    설정 저장
                </button>
            </div>

            <div className="grid grid-4" style={{ gap: '20px' }}>
                {/* 사이드바 탭 */}
                <div className="card" style={{ height: 'fit-content' }}>
                    <nav>
                        {tabs.map((tab) => {
                            const Icon = tab.icon;
                            const isActive = activeTab === tab.id;

                            return (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        width: '100%',
                                        padding: '12px 16px',
                                        margin: '4px 0',
                                        backgroundColor: isActive ? '#f3f4f6' : 'transparent',
                                        border: 'none',
                                        borderRadius: '8px',
                                        color: isActive ? '#1f2937' : '#6b7280',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: isActive ? 500 : 400,
                                        textAlign: 'left',
                                        transition: 'all 0.2s'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isActive) {
                                            e.target.style.backgroundColor = '#f9fafb';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isActive) {
                                            e.target.style.backgroundColor = 'transparent';
                                        }
                                    }}
                                >
                                    <Icon size={18} />
                                    <span>{tab.label}</span>
                                </button>
                            );
                        })}
                    </nav>
                </div>

                {/* 메인 콘텐츠 */}
                <div className="card" style={{ gridColumn: '2 / -1' }}>
                    {renderTabContent()}
                </div>
            </div>
        </div>
    );
};

export default Settings;